import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './global.css'

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://519e3b8b381dd60660c6a2029364a681@o4509352084045824.ingest.us.sentry.io/4509352100102144",
  environment: import.meta.env.VITE_SENTRY_ENV || 'localhost',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: true,
    })
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/status\.bot/],
  // Session Replay
  replaysSessionSampleRate: 0.5, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

});

createRoot(document.getElementById('root')).render(
  <App />
)
